import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { HousingSubscription, HousingCustomer, HousingProduct, DocumentType, HCustomerSubscriptionDto } from '../../api/models';
import { SessionService } from '../../common/session.service';
import { HSubscriptionControllerService } from '../../api/services';
import { HProductControllerService } from '../../api/services';
import * as bootstrap from 'bootstrap';
import { Router } from '@angular/router';
import { constants } from '../../common/constants';

@Component({
    selector: 'app-hsubscription',
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    templateUrl: './hsubscription.component.html',
    styleUrl: './hsubscription.component.css'
})
export class HsubscriptionComponent implements OnInit {

    subscriptionForm: FormGroup;
    searchForm: FormGroup;
    submitted = false;
    showSearch = false;
    promoterId: number = 0;
    products: HousingProduct[] = [];
    selectedProduct: HousingProduct|null=null;
    allSubscriptions: HousingSubscription[] = [];
    subscriptions: HousingSubscription[] = [];
    existingCustomer?: HousingCustomer;
    alreadySubscriptions: HousingSubscription[] = [];
    alreadySubscribedProducts: Set<String> = new Set();
    customerFound = false;
    phoneChecked = false;
    message = '';
    messageType: 'text-success'|'text-info' | 'text-danger' = 'text-success';
    countries=constants.ALL_CONTRIES;

    documentTypes: DocumentType[] = [
        { code: 'CNI', libelle: 'Carte Nationale d\'Identité' },
        { code: 'PP', libelle: 'Passeport' }
    ];

   
    modal: bootstrap.Modal | undefined;

    constructor(
        private formBuilder: FormBuilder,
        private sess: SessionService,
        private router: Router,
        private subscriptionService: HSubscriptionControllerService,
        private productService: HProductControllerService
    ) {
        this.subscriptionForm = this.formBuilder.group({
            firstName: ['', [Validators.required]],
            lastName: ['', [Validators.required]],
            phone: ['', [Validators.required,Validators.minLength(9), Validators.pattern('^[0-9+]+$')]],
            email: ['', [ Validators.email]],
            documentId: ['', [Validators.required]],
            documentType: ['', Validators.required],
            address: [''],
            cityResidence: [''],
            countryResidence: ['',Validators.required],
            paymentFrequency: ['', [Validators.required]],
            productId:['',Validators.required],
            periodicAmount:['',[Validators.required]],
            durationYears: [1, [Validators.required, Validators.min(1), Validators.max(30)]]
        });

        this.searchForm = this.formBuilder.group({
            searchPhone: ['', [Validators.required, Validators.pattern('^[0-9+]+$')]]
        });
    }

    ngOnInit(): void {
        const sess = this.sess.getSessionInfo();
        if (sess.partner?.type == 'MERCHANT') {
            this.promoterId = sess.partner?.id!!;
            this.loadProducts();
        }
    }

    ngAfterViewInit() {
    this.modal =new bootstrap.Modal('#modalSubscription', {});
}

    get f() {
        return this.subscriptionForm.controls;
    }

    get s() {
        return this.searchForm.controls;
    }

    loadProducts(): void {
        this.productService.getProductsByPromoter(
             this.promoterId,
         {
                page: 0,
                size: 20, // Load all products for selection
                sort: ['modifiedAt,desc']
            }
        ).subscribe({
            next: (response) => {
                this.products = response.content || [];
                console.debug('Produits chargés avec succès', response);
            },
            error: (error: HttpErrorResponse) => {
                this.messageType = 'text-danger';
                this.message = 'Erreur lors du chargement des produits';
                console.error('Erreur lors du chargement des produits', error);
            }
        });
    }

   
    searchCustomer(): void {
        if (this.searchForm.invalid) {
            return;
        }

        const phone = this.searchForm.value.searchPhone.trim();
        
        // TODO: Replace with actual API call to search customer by phone
        // For now, simulate customer search with mock data
        this.searchCustomerByPhone(phone);
    }

    subscriptionByPhone(): void {
        if (!this.subscriptionForm.value.phone || this.subscriptionForm.get('phone')?.invalid) {
            this.messageType = 'text-danger';
            this.message = 'Veuillez saisir un numéro de téléphone valide.';
            return;
        }

        const phone = this.subscriptionForm.value.phone.trim();
        
        // TODO: Replace with actual API call to search customer by phone
        // For now, simulate customer search with mock data
        this.searchCustomerByPhone(phone);
        
    }

    private searchCustomerByPhone(phone: string): void {
        
        this.subscriptionService.findByPhone( phone).subscribe({
            next: (response: HCustomerSubscriptionDto) => {
                this.customerFound = true;
                this.prefillFormWithCustomer(response!!);
                this.phoneChecked = true;
                ;
            },
            error: (error: HttpErrorResponse) => {
                this.phoneChecked = true;
                if (error.status === 404) {
                    // Customer not found
                    this.existingCustomer = undefined;
                    this.customerFound = false;
                    this.selectedProduct = null;
                    this.alreadySubscriptions
                    this.messageType = 'text-info';
                         } else {
                    // Other errors
                    this.messageType = 'text-danger';
                    this.message = error.error?.message || 'Erreur lors de la recherche du client';
                    console.error('Erreur lors de la recherche du client', error);
                }
            }
        });

      
    }

    private prefillFormWithCustomer(subscription: HCustomerSubscriptionDto): void {
        const customer = subscription.customer!!;
        this.subscriptionForm.patchValue({
            id: customer.id,
            firstName: customer.firstName,
            lastName: customer.lastName,
            phone: customer.phone,
            email: customer.email,
            documentId: customer.documentId,
            documentType: customer.documentType?.code,
            address: customer.address,
            cityResidence: customer.cityResidence,
            countryResidence: customer.countryResidence?.isoCode2
        });
        this.existingCustomer = customer;
        // Pre-select the product if the subscription has one
        this.alreadySubscriptions = subscription.subscriptions || [];

        this.alreadySubscribedProducts = new Set(this.alreadySubscriptions.map(sub => sub.product!.id!));
        this.customerFound = true;
        this.products =this.products.filter(p => !this.alreadySubscribedProducts.has(p.id!!));
    
    }

    toggleProductSelection(product: HousingProduct): void {
        this.selectedProduct=product;
    }

   

   

    submitSubscription(): void {
        this.submitted = true;
        if (this.subscriptionForm.invalid) {
            return;
        }

        const customer: HousingCustomer = {
            id: this.subscriptionForm.value.id,
            firstName: this.subscriptionForm.value.firstName,
            lastName: this.subscriptionForm.value.lastName,
            phone: this.subscriptionForm.value.phone,
            email: this.subscriptionForm.value.email,
            documentId: this.subscriptionForm.value.documentId,
            documentType: this.documentTypes.find(dt => dt.code === this.subscriptionForm.value.documentType),
            address: this.subscriptionForm.value.address,
            cityResidence: this.subscriptionForm.value.cityResidence,
            countryResidence: {
                isoCode2: this.subscriptionForm.value.countryResidence}
        };

        // Create subscriptions for each selected product
        const subscriptions: HousingSubscription = {
            customer: customer,
            product: {
                id: this.selectedProduct?.id
            },
            paymentFrequency: this.subscriptionForm.value.paymentFrequency,
            periodicAmount: this.subscriptionForm.value.periodicAmount,
            };

        // For now, create one subscription. In a real scenario, you might want to handle multiple
        this.createSubscription(subscriptions);
    }

    createSubscription(subscription: HousingSubscription): void {
        this.subscriptionService.subscribe1( subscription).subscribe({
            next: (response: HousingSubscription) => {
                console.log('Souscription créée avec succès', response);
                this.messageType = 'text-success';
                this.message = 'Souscription créée avec succès';
                this.selectedProduct=null;
                // Add the new subscription to the list
                //this.subscriptions.unshift(response);
                this.resetForm();                
                this.modal?.show();

            },
            error: (error: HttpErrorResponse) => {
                this.messageType = 'text-danger';
                this.message = error.error?.message || 'Erreur lors de la création de la souscription';
                this.modal?.show();
                console.error('Erreur lors de la création de la souscription', error);
            }
        });
    }

    resetForm(): void {
        this.subscriptionForm.reset({
            countryResidence: 'SN'
        });
        this.searchForm.reset();
        this.submitted = false;
        this.existingCustomer = undefined;
        this.customerFound = false;
        this.phoneChecked = false;
        this.selectedProduct = null;
        this.showSearch = false;
    }

    resetPhoneCheck(): void {
        this.phoneChecked = false;
        this.customerFound = false;
        this.existingCustomer = undefined;
        this.selectedProduct = null;
        this.message = '';
        // Keep the phone value but clear other fields
        const phoneValue = this.subscriptionForm.value.phone;
        this.subscriptionForm.reset({
            phone: phoneValue,
            countryResidence: 'SN'
        });
    }

    goToViewSubscriptions(): void {
        // This method can be used to navigate to the subscriptions list view
        this.router.navigate(['/housing/subscriptions']);
    }

    toggleSearch(): void {
        this.showSearch = !this.showSearch;
        if (!this.showSearch) {
            this.searchForm.reset();
            this.existingCustomer = undefined;
            this.customerFound = false;
            this.resetForm();
        }
    }
    calculatePeridicAmount(){
        console.log("calculatePeridicAmount");
        if(this.selectedProduct==null) return;
        console.log("calculatePeridicAmount "+this.selectedProduct.name);
        const product =this.selectedProduct;
        const form =this.subscriptionForm.getRawValue();
        const years =product?.durationYears;
        const frequence =form.paymentFrequency;
        const price = product?.price;
        console.log(frequence);
        this.subscriptionForm.get('periodicAmount')?.enable();
        console.log("values", years,price);
        console.log(years &&years>0,price&&price>0)
        if(years &&years>0 &&price &&price>0 && frequence.length>0){
            
            const mensuelAmount=price/(years*12);
            console.log(mensuelAmount);

            const periodicAmount=this.getMultiplier(frequence)*mensuelAmount;
             console.log(periodicAmount);
            this.subscriptionForm.patchValue({
                'periodicAmount':periodicAmount
            });
            

        }else {
            this.subscriptionForm.patchValue({
                'periodicAmount':0
            });
        }
         this.subscriptionForm.get('periodicAmount')?.disable();
    }
    getMultiplier(frequency:string){

        switch(frequency.toUpperCase()){
            case 'MENSUEL': return 1;
            case 'SEMESTRIEL': return 6;
            case 'TRIMESTRRIEL':return 3;
            case 'ANNUEL': return 12;
            default : return 1;
        }
    }
}